/**
 * @tabler/icons-solidjs v2.32.0 - MIT
 */

import createSolidComponent from '../createSolidComponent.js';

var IconLocationX = createSolidComponent("location-x", "IconLocationX", [
  [
    "path",
    {
      d: "M13.5 21l-.224 -.448l-3.276 -6.552l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5l-3.622 10.03"
    }
  ],
  ["path", { d: "M22 22l-5 -5" }],
  ["path", { d: "M17 22l5 -5" }]
]);

export { IconLocationX as default };
//# sourceMappingURL=IconLocationX.js.map
